import React from 'react'
import games from '@/shared/assets/games.webp'
import lines from '@/shared/assets/jackpotLines.webp'
import { ReactComponent as Pluses } from '@/shared/assets/pluses.svg'
import { ReactComponent as VioletGlow } from '@/shared/assets/violetGlow.svg'
import { ReactComponent as RedGlow } from '@/shared/assets/redGlow.svg'
import cls from './GamesBlock.module.scss?'
export const GameBlock = () => {
    return (
        <section className={cls.GameBlock}>
            <div className={cls.lines}>
                <div className={cls.firstLine} />
                <div className={cls.secondLine} />
            </div>
            <Pluses className={cls.pluses} />
            <div className={cls.blockContainer}>
                <div className={cls.text}>
                    <h3>Many games</h3>
                    <p>
                        We seamlessly blend the casino gambling industry with cutting-edge technologies to deliver
                        unparalleled gaming experiences. We are at the forefront of innovation, and we are awesome!
                    </p>
                </div>
                <div className={cls.gamesContainer}>
                    <VioletGlow className={cls.violetGlow} />
                    <RedGlow className={cls.redGlow} />
                    <RedGlow className={cls.redGlow2} />
                    <img
                        src={games}
                        alt="games"
                    />
                </div>
            </div>
        </section>
    )
}
